import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { DataGrid } from "@mui/x-data-grid";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import DataGridFilters from "SharedComponents/DataGrid/Filters";
import _ from "lodash";
import { useFormik } from "formik";
import Pagination from "@mui/material/Pagination";

//Services
import usersApi from "Services/GetUsers";
import LocationApi from "Services/Location";

//Modals
import UpdateLocationModal from "Pages/Modals/Location/UpdateLocation";
import DeleteLocationModal from "Pages/Modals/Location/DeleteLocation"

const ListLocation = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [updateLocationModal, setUpdateLocationModal] = useState(false);
  const [row, setRow] = useState([]);

  const [locationData, setLocationData] = useState([]);
  const [locationId, setLocationId] = useState(null);

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  // Location details modal
  const handleOpenUpdateLocationModal = (row) => {
    setLocationId(row?._id);
    setUpdateLocationModal(true);
  };

  const handleCloseUpdateLocationMoal = (row) => {
    setLocationId(row?._id);
    setUpdateLocationModal(false);
    getLocationList();
  };

const [deleteLocationModal, setdeletelocationModal] = useState(false);

    // Location details modal
  const handleOpenDeleteLocation = (row) => {
    setLocationId(row?._id);
    setdeletelocationModal(true);
  };

  const handleCloseDeleteLocation = (row) => {
    setLocationId(row?._id);
    setdeletelocationModal(false);
    getLocationList();
  };

  // Get location list api
  const getLocationList = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    LocationApi.getServiceArea({ page, limit: pageSize }).then(
      onSuccess,
      onFailure
    );
  }, [page, pageSize]);

  useEffect(() => {
    getLocationList();
  }, [getLocationList]);

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    location: data?.locationName,
    country: data?.countryId,
    row: data,
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "location",
      headerName: "Location",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.location}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "country",
      headerName: "Country",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.country}</Typography>
            </div>
          </>
        );
      },
    },
{
  field: "actions",
  headerName: "Actions",
  flex: 1,
  sortable: false,
  disableColumnMenu: true,
  renderCell: (params) => {
    return (
      <div className={classes.iconsWrapper}>
        {/* Edit Icon */}
        <section className={classes.editIcon}>
          <EditOutlinedIcon
            onClick={() =>
              handleOpenUpdateLocationModal(params?.row?.row)
            }
            style={{ cursor: "pointer", color: "#ffffffff" }}
          />
        </section>

        {/* Delete Icon */}
        <section className={classes.deleteIcon}>
          <DeleteOutlineOutlinedIcon
            onClick={() =>
              handleOpenDeleteLocation(params?.row?.row)
            }
            style={{ cursor: "pointer", color: "#ffffffff" }}
          />
        </section>
      </div>
    );
  },
}

  ];

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
            />
          </section>
        </Grid>
      </Grid>
      <UpdateLocationModal
        open={updateLocationModal}
        handleClose={handleCloseUpdateLocationMoal}
        locationId={locationId}
      />
            <DeleteLocationModal
            openDialog={deleteLocationModal}
            id={locationId}
            handleClose={handleCloseDeleteLocation}
          ></DeleteLocationModal>
    </>
  );
};

export default ListLocation;
